import has from 'lodash/has';
import CarpoolToWork from './CarpoolToWork';
import ChooseEnergyStarFridge from './ChooseEnergyStarFridge';
import EatLowCarbonDiet from './EatLowCarbonDiet';
import EfficientCoolingEquipment from './EfficientCoolingEquipment';
import EfficientHeatingEquipment from './EfficientHeatingEquipment';
import EnergyStarComputers from './EnergyStarComputers';
import EnergyStarCopiers from './EnergyStarCopiers';
import EnergyStarPrinters from './EnergyStarPrinters';
import GoOrganic from './GoOrganic';
import InstallHotWaterHeater from './InstallHotWaterHeater';
import InstallLowFlowShowerheads from './InstallLowFlowShowerheads';
import InstallPvPanels from './InstallPvPanels';
import InstallTanklessWaterHeater from './InstallTanklessWaterHeater';
import InstallWaterEfficientLandscaping from './InstallWaterEfficientLandscaping';
import LineDryClothing from './LineDryClothing';
import LowFlowFaucets from './LowFlowFaucets';
import LowFlowToilet from './LowFlowToilet';
import MaintainMyVehicles from './MaintainMyVehicles';
import PlantTrees from './PlantTrees';
import PowerManagementOfComputers from './PowerManagementOfComputers';
import PracticeEcoDriving from './PracticeEcoDriving';
import PrintDoubleSided from './PrintDoubleSided';
import PurchaseAlternativeFuelVehicle from './PurchaseAlternativeFuelVehicle';
import PurchaseElectricVehicle from './PurchaseElectricVehicle';
import PurchaseGreenElectricity from './PurchaseGreenElectricity';
import PurchaseHybridVehicle from './PurchaseHybridVehicle';
import PurchaseMoreEfficientVehicle from './PurchaseMoreEfficientVehicle';
import ReduceAirTravel from './ReduceAirTravel';
import ReduceYourWaste from './ReduceYourWaste';
import RideMyBike from './RideMyBike';
import SwitchT12ToT8Lights from './SwitchT12ToT8Lights';
import SwitchToCfl from './SwitchToCfls';
import TakePublicTransportation from './TakePublicTransportation';
import TelecommuteToWork from './TelecommuteToWork';
import TurnDownThermostatInWinter from './TurnDownThermostatInWinter';
import TurnOffLights from './TurnOffLights';
import TurnUpThermostatInSummer from './TurnUpThermostatInSummer';
import UseRechargeableBatteries from './UseRechargeableBatteries';

const detailsMap = {
  carpool_to_work: CarpoolToWork,
  purchase_high_efficiency_cooling: EfficientCoolingEquipment,
  purchase_high_efficiency_heating: EfficientHeatingEquipment,
  energy_star_copiers: EnergyStarCopiers,
  energy_star_desktops: EnergyStarComputers,
  energy_star_fridge: ChooseEnergyStarFridge,
  energy_star_printers: EnergyStarPrinters,
  go_organic: GoOrganic,
  low_carbon_diet: EatLowCarbonDiet,
  low_flow_showerheads: InstallLowFlowShowerheads,
  install_solar_heating: InstallHotWaterHeater,
  install_PV_panels: InstallPvPanels,
  line_dry_clothing: LineDryClothing,
  low_flow_faucets: LowFlowFaucets,
  low_flow_toilet: LowFlowToilet,
  maintain_my_vehicles: MaintainMyVehicles,
  plant_trees: PlantTrees,
  power_mgmt_comp: PowerManagementOfComputers,
  practice_eco_driving: PracticeEcoDriving,
  alternativefuel_vehicle: PurchaseAlternativeFuelVehicle,
  electric_vehicle: PurchaseElectricVehicle,
  purchase_green_electricity: PurchaseGreenElectricity,
  hybrid_vehicle: PurchaseHybridVehicle,
  more_efficient_vehicle: PurchaseMoreEfficientVehicle,
  print_double_sided: PrintDoubleSided,
  rechargeable_batteries: UseRechargeableBatteries,
  reduce_air_travel: ReduceAirTravel,
  reduce_comm_waste: ReduceYourWaste,
  ride_my_bike: RideMyBike,
  switch_to_cfl: SwitchToCfl,
  T12toT8: SwitchT12ToT8Lights,
  take_public_transportation: TakePublicTransportation,
  tankless_water_heater: InstallTanklessWaterHeater,
  telecommute_to_work: TelecommuteToWork,
  thermostat_summer: TurnUpThermostatInSummer,
  thermostat_winter: TurnDownThermostatInWinter,
  turn_off_lights: TurnOffLights,
  water_efficient_landscaping: InstallWaterEfficientLandscaping,
};

export default {
  has: apiKey => has(detailsMap, apiKey.replace(/^input_takeaction_/, '')),
  get: apiKey => detailsMap[apiKey.replace(/^input_takeaction_/, '')],
};
